import {inject, Injectable} from '@angular/core';

import {OrderQueryService} from '@features/sales/application/store/order/order-query.service';
import {CartOrderUnpaidEvent} from '@platform/event-bus/domain/events/cart/cart-order-unpaid.event';
import {EventBusPort} from '@platform/event-bus/domain/ports/event-bus.port';

@Injectable({providedIn: 'root'})
export class NotifyUnpaidOrderUseCase {
  private readonly orders = inject(OrderQueryService);
  private readonly eventBus = inject(EventBusPort);

  execute(cartId: string): void {
    const order = this.orders.findUnpaid(cartId);

    if (!order) {
      return;
    }

    this.eventBus.publish(new CartOrderUnpaidEvent({order: order.toDTO()}));
  }
}
